import * as React from 'react'

export const GettingInMobileSvg: React.FC = props => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 833.32 857.03"
    data-testid="getting-in-mobile-svg"
    {...props}
  >
    <defs>
      <clipPath id="clip-path">
        <path className="cls-1" d="M1.69 0h819.79v846.5H1.69z" />
      </clipPath>
      <clipPath id="clip-path-2">
        <path
          className="cls-1"
          d="M226.25 563.57H13V294.76h213.25Zm225.52-268.81H238.55v268.81h213.22Zm225.52 0H464.07v268.81h213.22Zm-451-282.93H13v268.81h213.25Zm225.52 0H238.55v268.81h213.22Zm225.52 0H464.07v268.81h213.22Zm-451 565.86H13V846.5h213.25Zm225.52 0h-213.3V846.5h213.22Zm225.52 0h-213.3V846.5h213.22Z"
        />
      </clipPath>
      <clipPath id="clip-path-3">
        <path className="cls-1" d="M13.91 11.83h662.5V846.5H13.91z" />
      </clipPath>
      <style>
        {
          '.cls-1{fill:none}.cls-11,.cls-6{opacity:.5}.cls-11,.cls-7{fill:#e2b5d9}.cls-8,.cls-9{fill:#ce95c6}.cls-9{opacity:.21}.cls-12{fill:#dea382}.cls-13{fill:#22d6b7}.cls-14{fill:#cb3974}.cls-15{fill:#db598c}.cls-16{fill:#9eefe1}.cls-17{fill:#371447}.cls-19{fill:#3d0d01}'
        }
      </style>
    </defs>
    <g
      style={{
        clipPath: 'url(#clip-path)',
      }}
    >
      <g
        style={{
          clipPath: 'url(#clip-path-2)',
        }}
      >
        <g
          style={{
            clipPath: 'url(#clip-path-3)',
          }}
        >
          <path
            style={{
              fill: '#edd3e6',
            }}
            d="M13.91 11.83h662.5V846.5H13.91z"
          />
          <g className="cls-6">
            <path className="cls-7" d="M341.56 12.35h7.21V73h-7.21z" />
            <circle className="cls-7" cx={345.16} cy={163.35} r={91.62} />
          </g>
          <path
            className="cls-7"
            d="m478.65 210.49-7.07-1.9a2.91 2.91 0 0 1 0-5.63l7.07-1.91a2.9 2.9 0 0 0 2.05-2.05l1.91-7.07a2.92 2.92 0 0 1 5.63 0l1.91 7.07a2.9 2.9 0 0 0 2.05 2.06l7.07 1.91a2.91 2.91 0 0 1 0 5.63l-7.07 1.9a2.92 2.92 0 0 0-2.05 2.06l-1.91 7.07a2.91 2.91 0 0 1-5.63 0l-1.91-7.07a2.92 2.92 0 0 0-2.05-2.07Z"
          />
          <path
            className="cls-8"
            d="m177.35 80.82-7.48-2a3.09 3.09 0 0 1 0-6l7.48-2a3.11 3.11 0 0 0 2.18-2.18l2-7.48a3.09 3.09 0 0 1 6 0l2 7.48a3.11 3.11 0 0 0 2.18 2.18l7.48 2a3.09 3.09 0 0 1 0 6l-7.48 2a3.11 3.11 0 0 0-2.19 2.18l-2 7.48a3.09 3.09 0 0 1-6 0l-2-7.48a3.11 3.11 0 0 0-2.17-2.18ZM519 132.49l-12.4-3.34a5.12 5.12 0 0 1 0-9.88l12.4-3.34a5.12 5.12 0 0 0 3.61-3.61L526 99.91a5.12 5.12 0 0 1 9.89 0l3.34 12.41a5.12 5.12 0 0 0 3.61 3.61l12.4 3.34a5.12 5.12 0 0 1 0 9.88l-12.4 3.34a5.12 5.12 0 0 0-3.61 3.61l-3.34 12.41a5.12 5.12 0 0 1-9.89 0l-3.34-12.41a5.12 5.12 0 0 0-3.66-3.61Z"
          />
          <g className="cls-6">
            <path
              className="cls-8"
              d="M105.18 788.4 71.19 946.52l104.73 2.46 10.27-24.64 4.93 26.69 89.12-3.28-36.95-162.45-138.11 3.1zM241.62 758.37c.17 2.84-28.69 20.42-65.9 22.66s-68.7-11.72-68.87-14.56 29.86-7 67.08-9.2 67.52-1.74 67.69 1.1ZM184.12 322.17s-26.57-35.43-67.07-5.45c0 0-56.06-5.84-49.83 44.78 0 0-53.74 33.86-21.42 53.73 0 0-32.54 51.48 10.51 57.23 0 0-8.26 33.18 19.86 38.55 0 0 17.84 38.77 60.35 16.49 0 0 36.44 16 72.81 0 0 0 43.43-.79 39.72-28.95 0 0 36.94-13.49 14.4-56.46 0 0 29.21-4.07 14-38.33 0 0 17.61-41.62-20.24-42.26 0 0 2.07-26.84-32.82-26.2.02 0-11.54-27.21-40.27-13.13Z"
            />
            <path
              className="cls-8"
              d="M200.12 495.12s-2.6 39.22 3.34 54l-62.89 4.79s-5.2-52.2 2.34-64.54 57.21 5.75 57.21 5.75Z"
            />
            <path
              className="cls-8"
              d="M188.71 515.58c4-.26-44.85-38.22-47.92-33.68-4.59 6.8-1.85 45.6-1.85 45.6s10.7-9.34 49.77-11.92Z"
            />
            <path
              className="cls-8"
              d="M192.63 373.89c2.51.87 5 1.84 7.44 2.86 5.62 2.32 11.29 5 15.55 9.31 13 13.26 7.82 28.37 7.52 46-.24 14-3.19 27.81-3.41 41.8-.25 16.19-19.2 62.44-75.36 35.57-10.18-4.86-17.8-14.13-23-24.14s-8.17-22.85-9.11-34.1c-1.67-20 2.23-40.89 13.84-57.23a57.28 57.28 0 0 1 51.83-23.56 65.64 65.64 0 0 1 14.7 3.49Z"
            />
            <path
              className="cls-8"
              d="M184.12 487.45s-16.94 10.42-31.94-4.83"
            />
            <circle className="cls-9" cx={205.13} cy={453.4} r={12.95} />
            <path
              className="cls-8"
              d="M178.06 436.78c4.15 7 3.65 23 3.23 27.26-.25 2.56-.63 5.3-2.45 7.14-2.67 2.69-7.15 2.34-11 1.77-4.16-.62-9-1.75-10.7-5.47-.92-2-.69-4.24-.34-6.36a68.49 68.49 0 0 1 5.81-18.51c1.29-2.69 2.84-5.39 5.32-7.14 4.89-3.47 8.07-2.16 10.13 1.31ZM130.25 437.42c.18.9-2.06-3.24-1.9-2.43a40 40 0 0 1 1 10.28c-.18 4.87-1.68 9.87-5.09 13.35-1.75 1.8-4.42 3.19-6.73 2.21a7.29 7.29 0 0 1-2.45-2c-8.17-9-16.51-18-15.62-30.94.31-4.57 1.65-9.22 4.65-12.67s6.8-6.66 11.17-6.08c0 0 13.93.71 14.07 24.08"
            />
            <path
              className="cls-8"
              d="M108.67 424.87c-2.73 1.81-3.81 5.48-3.24 8.72a17 17 0 0 0 4.78 8.44"
            />
            <circle className="cls-9" cx={134.88} cy={448.08} r={12.95} />
            <path
              className="cls-8"
              d="M89.41 403.16s30.83 37.29 58.42 11.68c0 0 12.49 10.23 32.68 9.24 15.17-.75 23-9.24 23-9.24s20.3 21.76 28.09 20.29 17.11-62.56 17.11-62.56l-97.73-19.2ZM140.57 553.91l27.58 119.8 35.31-124.59-62.89 4.79z"
            />
            <path
              className="cls-8"
              d="M194.65 594.2s53.67 144.46 111 162.13C378.43 778.79 396.38 587 396.38 587l-35.59-12.69s-37.3 107-52 97-55.41-110.49-55.41-110.49-10-24.83-53.81-6.9c-40.57 16.63-4.92 40.28-4.92 40.28Z"
            />
            <path
              className="cls-8"
              d="M109.82 556.5 139 552a1.85 1.85 0 0 1 2 1.08l29.36 67.3a1.83 1.83 0 0 0 3.36 0L203 550.14a1.81 1.81 0 0 1 1.54-1.11l24.82-2.03a1.84 1.84 0 0 1 1.95 1.48s22.58 69.91 12.46 117.28c-10.68 50-10.07 97.7-10.07 97.7s-64.67 22.51-114.2 13c0 0-30-116.24-11.22-218.31a1.91 1.91 0 0 1 1.54-1.65ZM114.82 415l2 26.47a1.33 1.33 0 0 0 2.53.48l15.56-32.82Z"
            />
            <circle className="cls-8" cx={113.68} cy={456.13} r={2.73} />
            <path
              className="cls-8"
              d="M108.28 558.16S34 565.61 0 740.16l8.22 76.48 93.84-175.91ZM107.09 766.55s108.6 13.63 134.53-8.18l1.67 26.93s-86.24 33.54-138.11 10ZM407.13 491.71c-6.56-8.22-11.69 25.41-15.56 19.52s2.39-34 5.92-41.61 8.53-17.25-2.5-16.13c-4.51.46-11 9.91-17.23 21.87a46.44 46.44 0 0 1 1.17-5.51c2.44-8 6.05-18.26-4.72-15.62s-17.82 57-18.41 71.14a59.62 59.62 0 0 0 3.92 23.06c.74 3 1.56 5.57 2.23 7.51 2.14 6.15-3.6 22.38-3.6 22.38L348 608.62s40.26 33 44.23 14.7c5.24-24.14 8.16-69.15 8.16-69.15s2.66-4.65 6.42-12.91c4.65-10.15 5.29-43.33.32-49.55Z"
            />
          </g>
          <g className="cls-6">
            <path
              className="cls-7"
              d="M441.4 439.44s22.08 45 16.42 62.27l57.84-.56s1.63-59.58-8.18-72.94-66.08 11.23-66.08 11.23Z"
            />
            <path
              className="cls-7"
              d="M439.64 450.56c-4.55-1.22 67.87-56 71.93-51.19 5.48 6.51 4.19 90.25 4.19 90.25s-24.22-25.17-76.12-39.06Z"
            />
            <path
              className="cls-7"
              d="m408.29 411.25-2.55-.84c-3.85-1.27-10.55-2.94-11-7.25-.65-6.32 5.57-11.56 7.72-17.27a71.86 71.86 0 0 0 4.16-27.89c-.26-7.15-4.47-14.07-5.68-21.18-1.29-7.54-.29-15 4.93-21 4.59-5.27 11-8.74 17.31-11.84 2.77-1.35 5.57-2.65 8.42-3.84a77.25 77.25 0 0 1 16.81-5.14c23-4 47.41 4.88 62.29 22.43s21.2 40.94 20.94 63.7c-.14 12.81-2.51 27.61-7.71 39.38s-13.29 22.89-24.72 29.25c-63.07 35.06-89-15.78-90.69-34.1-.14-1.54-.2-2.99-.23-4.41Z"
            />
            <ellipse
              cx={456.5}
              cy={385.61}
              rx={15.1}
              ry={14.71}
              style={{
                opacity: 0.25,
                fill: '#e2b5d9',
              }}
            />
            <path
              className="cls-7"
              d="M400.94 336.8s-51.63-64.95-9.34-66.59c66-2.56 102.32-20.77 132 10.71s45.82 38.35 3 132.64c0 0-10.67-86.55-40.12-87.65-27.13-1.02-85.54 10.89-85.54 10.89Z"
            />
            <path
              className="cls-7"
              d="M504.05 365.31c-.13.93 1.92-3.49 1.81-2.65a40 40 0 0 0-.26 10.65c.56 5 2.53 10 6.39 13.34 2 1.72 4.91 2.94 7.28 1.77a7.7 7.7 0 0 0 2.44-2.21c7.93-9.89 16-19.72 14.11-33-.68-4.67-2.44-9.35-5.88-12.68s-7.69-6.33-12.26-5.41c0 0-14.65 1.77-13 25.8M454.34 489.62s41.44 19.73 70.2 0l88.28 25.91a59.8 59.8 0 0 1 41.66 69.76L635.7 870.73l-236.27 18.71L403 584.15Z"
            />
            <path
              className="cls-7"
              d="M366.29 571.4c3.94-5.54 9.42-9.67 17.92-12.47a130.44 130.44 0 0 1 43.12-6.09c15.82.4 33.5 4 36 17.66 4.58 25.38-66.39 230.26-66.39 230.26s-43.09 171.75-95.45 204.63c0 0-37.34-7.53-55.6-21.78 18.53-34.71 27.29-66.22 44-101.86 18.74-40.06 32.31-78.22 38.46-122.29 7.89-56.49 14.21-112.18 29.39-167.29 2.26-8.36 4.63-15.26 8.55-20.77Z"
            />
            <path
              className="cls-7"
              d="m492.49 560.51-38.15-70.89-84 39.24a71.09 71.09 0 0 0-39 47.51l-17.01 160.84a2.93 2.93 0 0 0 2.27 3.17l100.52 22.54a2.92 2.92 0 0 0 3.4-1.87Z"
            />
          </g>
        </g>
      </g>
      <path
        className="cls-11"
        d="M216.55 11.83v259.11H13.91v9.7H226.25V11.83h-9.7zM441.63 11.83v259.11H238.99v9.7H451.33V11.83h-9.7zM667.15 11.83v259.11H464.51v9.7H676.85V11.83h-9.7zM216.55 294.76v259.11H13.91v9.7H226.25V294.76h-9.7zM441.63 294.76v259.11H238.99v9.7H451.33V294.76h-9.7zM666.5 294.76v259.11H463.87v9.7H676.2V294.76h-9.7zM216.55 577.69V836.8H13.91v9.7H226.25V577.69h-9.7zM441.63 577.69V836.8H238.99v9.7H451.33V577.69h-9.7zM667.15 577.69V836.8H464.51v9.7H676.85V577.69h-9.7z"
      />
      <path
        className="cls-12"
        d="m619.9 727.56 6.86 69.66-184.41 6.35 33.02-119.63 144.53 43.62z"
      />
      <path
        className="cls-13"
        d="M456.88 751.46s-12.24 24.11-6.49 26.37 180.25 12.17 176.61 0 .06-36.92.06-36.92Z"
      />
      <rect
        className="cls-14"
        x={710.84}
        y={454.69}
        width={102.78}
        height={70.25}
        rx={0.5}
        transform="rotate(121.02 762.231 489.8)"
      />
      <path
        className="cls-15"
        d="m758.7 428.11 15 68.49a.18.18 0 0 1-.12.21l-67.44 18.8a.23.23 0 0 1-.25-.33l52.45-87.23a.18.18 0 0 1 .36.06Z"
      />
      <path
        className="cls-12"
        d="M603.42 465.26s-7.42 17.16 7.64 40c0 0 8 32-23.47 39.55s-53-31-53-31l3.28-21.17s14.15-32.64 7-55.72Z"
      />
      <path
        className="cls-16"
        d="M678.12 572.71S558.74 581.47 472 499.44c0 0-12.48 195.24-29.8 240.87-3.27 8.63.75 34.21 8.6 33.48 52.15-4.85 55.81 5.19 170.34 0 3.39-.15 6.65-.23 7-3.6Z"
      />
      <path
        className="cls-16"
        d="M609.87 503.37s-37.38 29.68-72-10.76c0 0-69.51-8.67-89.85 19.86-22.75 31.91-40.94 100-50.54 141.91a50.56 50.56 0 0 0 22.39 54.07l37.34 23.44c.72-2.82 9.35-129.56 12.13-130.4 17.2-5.22 82.43-18 178.88 47.74 0 0 53.14-52.07 40.51-93.88a57.83 57.83 0 0 0-4.82-11.35c-24.19-43.95-74.04-40.63-74.04-40.63Z"
      />
      <path
        className="cls-17"
        d="M606.73 455.46s-25.2-1.09-32.22-3.43l27.14 26.55s.35-14.58 5.08-23.12Z"
      />
      <path
        className="cls-13"
        d="m614.17 493.11 3.83 9.54a2.45 2.45 0 0 1-1.13 3.07 103 103 0 0 1-46.53 11.51c-31.07 0-49.86-11.45-52.27-18-1.25-3.35 1.4-7.94 4.27-11.59a14.58 14.58 0 0 1 12.51-5.54l71.2 5.05a9.47 9.47 0 0 1 8.12 5.96Z"
      />
      <path
        className="cls-12"
        d="M525.43 398.92c-1.68 16.49 56.92 71.17 79 62.88 16.75-6.29 42.53-24.12 36.71-52-4.66-22.42 11.06-37.7 4.47-52.76-16.05-36.7-45.61-53.93-78.61-45.44s-39.39 65.85-41.57 87.32Z"
      />
      <circle
        cx={619.55}
        cy={423.23}
        r={13.71}
        style={{
          fill: '#e1769e',
          opacity: 0.11,
        }}
      />
      <path
        className="cls-19"
        d="M645.93 308.59c3.55 1.3 8.2 7 9.86 10.4 5 10.13 21.78 34 1.11 55-29.43 29.93-57.5-1.55-54.43 6.91s7 27.48-7.31 33c-31.46 12.19-1 44.67-30.77 37.35-44.18-10.87-64.95-64.5-53.67-105.89 5.13-18.81 17.94-31.11 34.43-40.34 14.44-8.07 34.33-20.55 51.52-17.18 17.33 3.47 32.76 14.7 49.26 20.75Z"
      />
      <path
        className="cls-12"
        d="M604.76 389.34c1.26-.94 1.26-2.8.72-4.16s.61-3.52-.42-4.58c-1.49-1.53-4.68-4.18-6.84-4.84-3.78-1.15-7.73 1.2-10.79 3.72s-5 6.52-6 10.52c-2.72 11.32 3.33 20.49 9.21 29.68a6.55 6.55 0 0 0 1.87 2.11c1.9 1.2 4.46.37 6.28-1 3.53-2.57 5.6-6.77 6.49-11s.74-7.2.55-11.56l-.52-12.35"
      />
      <path
        className="cls-17"
        d="M593.4 385.72c-8.88 4.38-7 15-2.75 22.07a1.51 1.51 0 0 0 2.61-1.53c-3.37-5.62-5.73-14.28 1.66-17.93 1.75-.86.22-3.47-1.52-2.61Z"
      />
      <path
        className="cls-12"
        d="m738.38 601.58 47-14.68s.39-16.44 4.39-21.22 11.52-14.59 14-27.93.8-70.06-8.67-74.81-8.29 5.54-7.72 13.55-3.41 35.24-8.86 39.19 1.4-27.84-7.26-22.73c-6.55 3.87-17.26 33.72-16.58 44.37s2.67 9.89.54 17-16.84 47.26-16.84 47.26Z"
      />
      <path
        className="cls-12"
        d="m738 600.09 34.91-10.22s10.37-19.52 15-23.69 13.43-12.85 17.73-25.72 16.46-63.77 7.74-69.8-9 4.34-9.53 12.35-8.27 34.43-14.22 37.58-7.1 20.73-16.38 24.59c-7 2.93-9.43-17.11-10.24-6.48s1.28 10.18-1.82 16.93S738 600.09 738 600.09Z"
      />
      <path
        className="cls-16"
        d="M800.91 581.89a2.26 2.26 0 0 0-1.89-3l-2.59-.28-5.61-.54L779.6 577l-11.22-1.08-11.23-1.07-11.22-1.08-4.71-.45a8.51 8.51 0 0 0-4.73.46c-1.58.83-2.45 2.54-3.21 4.15l-19.54 40.83a.87.87 0 0 1-1.61-.14C704 590 695.48 561 678.73 536.43c-1.37-2-2.94-4.08-5.23-4.89-2.07-.72-4.35-.27-6.5.2-15.82 3.43-31.67 6.87-47.12 11.74-2.89.91-5.77 1.89-8.59 3a58 58 0 0 0-8.18 4A37 37 0 0 0 596 556c-.47.48-.92 1-1.36 1.47a4.29 4.29 0 0 0-.91 1.71 13.65 13.65 0 0 0-.21 5.44 41.87 41.87 0 0 0 1.25 5.54q15.26 54.58 30.5 109.17a108.3 108.3 0 0 0 5.25 14.67c15.31 34.69 46.67 91.65 92.42 72.83 8.86-3.65 15.8-11 20.69-19.23s8-17.41 11-26.5l3.56-10.71 3.56-10.7 3.54-10.69 3.56-10.7 3.56-10.71 3.56-10.7 3.56-10.71 3.56-10.71 3.57-10.7 3.56-10.77 3.56-10.71 3.56-10.7 3.56-10.71Z"
      />
      <path
        className="cls-19"
        d="M603.88 375.2c-1 3.1-6.67 22 .75 35.79a.81.81 0 0 0 1.52-.36c.12-3.27 1.42-9 6.7-18.34a229.09 229.09 0 0 1 12.87-20.71.81.81 0 0 0-.83-1.26l-20.41 4.35a.81.81 0 0 0-.6.53Z"
      />
      <circle className="cls-14" cx={595.61} cy={422.37} r={4.31} />
      <circle className="cls-14" cx={590.76} cy={427.22} r={4.31} />
      <circle className="cls-14" cx={589.78} cy={421.15} r={4.31} />
      <rect
        className="cls-15"
        x={532.54}
        y={251.43}
        width={4.04}
        height={138.44}
        rx={2.02}
        transform="rotate(28.09 534.477 320.592)"
      />
      <circle className="cls-19" cx={507.69} cy={300.86} r={51.08} />
      <circle className="cls-15" cx={567.2} cy={266.11} r={4.79} />
      <circle className="cls-15" cx={562.75} cy={271.88} r={3.61} />
      <path
        d="m626.74 805.26 2-8a1.88 1.88 0 0 0-1.85-2.35L442 797.5a1.88 1.88 0 0 0-1.86 2l.6 9.51a15.67 15.67 0 0 1-.26 3.93c-13.18 66.6-91.44 468.53-75.81 545a11.87 11.87 0 0 0 11.65 9.44H509.7a9 9 0 0 0 8.91-8l31.55-292.76 77.43 292.56a11.12 11.12 0 0 0 10.66 8.27c29.12.24 124.53.9 149-.07 27.08-1.07-138.58-491.79-160.29-556.18a10.47 10.47 0 0 1-.22-5.94Z"
        style={{
          fill: '#7d3ca0',
        }}
      />
    </g>
  </svg>
)
